export const MinPriceFreeShipping = 21000;
